// GENERIERT — nicht von Hand bearbeiten.
// Quelle: docs/warehouse-regalplan/REGALBELEGUNG PACKSTATION OG+EG 2024.xlsx
// Erzeugen mit: node scripts/warehouse/regalplan-export.mjs
//
// 1941 Faecher, davon 82 Doppelplaetze.
import type { RegalGeometrie } from '@/lib/handregal-geometrie'

export const GEOMETRIE: RegalGeometrie = {
  "stand": "2026-10-07",
  "quelle": "docs/warehouse-regalplan/REGALBELEGUNG PACKSTATION OG+EG 2024.xlsx",
  "bloecke": [
    {
      "etage": "EG",
      "band": 1,
      "seite": "links",
      "block": 1,
      "von": 721,
      "bis": 738,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 6,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 1,
      "seite": "links",
      "block": 2,
      "von": 703,
      "bis": 720,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 6,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 1,
      "seite": "links",
      "block": 3,
      "von": 685,
      "bis": 702,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 6,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 1,
      "seite": "links",
      "block": 4,
      "von": 667,
      "bis": 684,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 6,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 1,
      "seite": "rechts",
      "block": 5,
      "von": 769,
      "bis": 783,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 7,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 1,
      "seite": "rechts",
      "block": 6,
      "von": 754,
      "bis": 768,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 7,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 1,
      "seite": "rechts",
      "block": 7,
      "von": 739,
      "bis": 753,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 7,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "links",
      "block": 1,
      "von": 595,
      "bis": 612,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "links",
      "block": 2,
      "von": 613,
      "bis": 630,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "links",
      "block": 3,
      "von": 631,
      "bis": 648,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "links",
      "block": 4,
      "von": 649,
      "bis": 666,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "rechts",
      "block": 5,
      "von": 784,
      "bis": 801,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "rechts",
      "block": 6,
      "von": 802,
      "bis": 819,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 2,
      "seite": "rechts",
      "block": 7,
      "von": 820,
      "bis": 837,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 14,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "links",
      "block": 1,
      "von": 577,
      "bis": 594,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "links",
      "block": 2,
      "von": 559,
      "bis": 576,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "links",
      "block": 3,
      "von": 541,
      "bis": 558,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "links",
      "block": 4,
      "von": 523,
      "bis": 540,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "rechts",
      "block": 5,
      "von": 880,
      "bis": 903,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "rechts",
      "block": 6,
      "von": 856,
      "bis": 879,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 3,
      "seite": "rechts",
      "block": 7,
      "von": 838,
      "bis": 855,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 21,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "links",
      "block": 1,
      "von": 451,
      "bis": 468,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "links",
      "block": 2,
      "von": 469,
      "bis": 486,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "links",
      "block": 3,
      "von": 487,
      "bis": 504,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "links",
      "block": 4,
      "von": 505,
      "bis": 522,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "rechts",
      "block": 5,
      "von": 904,
      "bis": 927,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "rechts",
      "block": 6,
      "von": 928,
      "bis": 951,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 4,
      "seite": "rechts",
      "block": 7,
      "von": 952,
      "bis": 969,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 29,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "links",
      "block": 1,
      "von": 433,
      "bis": 450,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "links",
      "block": 2,
      "von": 415,
      "bis": 432,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "links",
      "block": 3,
      "von": 397,
      "bis": 414,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "links",
      "block": 4,
      "von": 379,
      "bis": 396,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "rechts",
      "block": 5,
      "von": 1012,
      "bis": 1035,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "rechts",
      "block": 6,
      "von": 988,
      "bis": 1011,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 5,
      "seite": "rechts",
      "block": 7,
      "von": 970,
      "bis": 987,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 36,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "links",
      "block": 1,
      "von": 295,
      "bis": 312,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "links",
      "block": 2,
      "von": 313,
      "bis": 336,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "links",
      "block": 3,
      "von": 337,
      "bis": 360,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "links",
      "block": 4,
      "von": 361,
      "bis": 378,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "rechts",
      "block": 5,
      "von": 1036,
      "bis": 1059,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "rechts",
      "block": 6,
      "von": 1060,
      "bis": 1083,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 6,
      "seite": "rechts",
      "block": 7,
      "von": 1084,
      "bis": 1101,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 44,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "links",
      "block": 1,
      "von": 277,
      "bis": 294,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "links",
      "block": 2,
      "von": 253,
      "bis": 276,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "links",
      "block": 3,
      "von": 229,
      "bis": 252,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "links",
      "block": 4,
      "von": 211,
      "bis": 228,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "rechts",
      "block": 5,
      "von": 1144,
      "bis": 1167,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "rechts",
      "block": 6,
      "von": 1120,
      "bis": 1143,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 7,
      "seite": "rechts",
      "block": 7,
      "von": 1102,
      "bis": 1119,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 51,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "links",
      "block": 1,
      "von": 141,
      "bis": 155,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "links",
      "block": 2,
      "von": 156,
      "bis": 175,
      "breite": 4,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "links",
      "block": 3,
      "von": 176,
      "bis": 195,
      "breite": 4,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "links",
      "block": 4,
      "von": 196,
      "bis": 210,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "rechts",
      "block": 5,
      "von": 1168,
      "bis": 1191,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "rechts",
      "block": 6,
      "von": 1192,
      "bis": 1215,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 8,
      "seite": "rechts",
      "block": 7,
      "von": 1216,
      "bis": 1233,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 59,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "links",
      "block": 1,
      "von": 126,
      "bis": 140,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 67,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "links",
      "block": 2,
      "von": 106,
      "bis": 125,
      "breite": 4,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 67,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "links",
      "block": 3,
      "von": 86,
      "bis": 105,
      "breite": 4,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 67,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "links",
      "block": 4,
      "von": 71,
      "bis": 85,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 67,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "rechts",
      "block": 5,
      "von": 1276,
      "bis": 1299,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 66,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "rechts",
      "block": 6,
      "von": 1252,
      "bis": 1275,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 66,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 9,
      "seite": "rechts",
      "block": 7,
      "von": 1234,
      "bis": 1251,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 66,
      "spalte": 25
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "links",
      "block": 1,
      "von": 1,
      "bis": 15,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 2
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "links",
      "block": 2,
      "von": 16,
      "bis": 35,
      "breite": 4,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 5
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "links",
      "block": 3,
      "von": 36,
      "bis": 55,
      "breite": 4,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 9
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "links",
      "block": 4,
      "von": 56,
      "bis": 70,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 13
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "rechts",
      "block": 5,
      "von": 1300,
      "bis": 1323,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 17
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "rechts",
      "block": 6,
      "von": 1324,
      "bis": 1347,
      "breite": 4,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 21
    },
    {
      "etage": "EG",
      "band": 10,
      "seite": "rechts",
      "block": 7,
      "von": 1348,
      "bis": 1365,
      "breite": 3,
      "hoehe": 6,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 74,
      "spalte": 25
    },
    {
      "etage": "OG",
      "band": 1,
      "seite": "links",
      "block": 1,
      "von": 1390,
      "bis": 1401,
      "breite": 3,
      "hoehe": 4,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 7,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 1,
      "seite": "links",
      "block": 2,
      "von": 1378,
      "bis": 1389,
      "breite": 3,
      "hoehe": 4,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 7,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 1,
      "seite": "links",
      "block": 3,
      "von": 1366,
      "bis": 1377,
      "breite": 3,
      "hoehe": 4,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 7,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 2,
      "seite": "links",
      "block": 1,
      "von": 1402,
      "bis": 1416,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 13,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 2,
      "seite": "links",
      "block": 2,
      "von": 1417,
      "bis": 1431,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 13,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 2,
      "seite": "links",
      "block": 3,
      "von": 1432,
      "bis": 1446,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 13,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 3,
      "seite": "links",
      "block": 1,
      "von": 1477,
      "bis": 1491,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 19,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 3,
      "seite": "links",
      "block": 2,
      "von": 1462,
      "bis": 1476,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 19,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 3,
      "seite": "links",
      "block": 3,
      "von": 1447,
      "bis": 1461,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 19,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 4,
      "seite": "links",
      "block": 1,
      "von": 1492,
      "bis": 1506,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 26,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 4,
      "seite": "links",
      "block": 2,
      "von": 1507,
      "bis": 1521,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 26,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 5,
      "seite": "links",
      "block": 1,
      "von": 1552,
      "bis": 1566,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 32,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 5,
      "seite": "links",
      "block": 2,
      "von": 1537,
      "bis": 1551,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 32,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 5,
      "seite": "links",
      "block": 3,
      "von": 1522,
      "bis": 1536,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 32,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 6,
      "seite": "links",
      "block": 1,
      "von": 1567,
      "bis": 1581,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 39,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 6,
      "seite": "links",
      "block": 2,
      "von": 1582,
      "bis": 1596,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 39,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 6,
      "seite": "links",
      "block": 3,
      "von": 1597,
      "bis": 1611,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 39,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 7,
      "seite": "links",
      "block": 1,
      "von": 1627,
      "bis": 1641,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 45,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 7,
      "seite": "links",
      "block": 2,
      "von": 1612,
      "bis": 1626,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 45,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 7,
      "seite": "rechts",
      "block": 3,
      "von": 1927,
      "bis": 1941,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 45,
      "spalte": 13
    },
    {
      "etage": "OG",
      "band": 7,
      "seite": "rechts",
      "block": 4,
      "von": 1912,
      "bis": 1926,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 45,
      "spalte": 19
    },
    {
      "etage": "OG",
      "band": 8,
      "seite": "links",
      "block": 1,
      "von": 1642,
      "bis": 1656,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 52,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 8,
      "seite": "links",
      "block": 2,
      "von": 1657,
      "bis": 1671,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 52,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 8,
      "seite": "links",
      "block": 3,
      "von": 1672,
      "bis": 1686,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 52,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 8,
      "seite": "rechts",
      "block": 4,
      "von": 1867,
      "bis": 1881,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 52,
      "spalte": 13
    },
    {
      "etage": "OG",
      "band": 8,
      "seite": "rechts",
      "block": 5,
      "von": 1882,
      "bis": 1896,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 52,
      "spalte": 16
    },
    {
      "etage": "OG",
      "band": 8,
      "seite": "rechts",
      "block": 6,
      "von": 1897,
      "bis": 1911,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 52,
      "spalte": 19
    },
    {
      "etage": "OG",
      "band": 9,
      "seite": "links",
      "block": 1,
      "von": 1717,
      "bis": 1731,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 58,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 9,
      "seite": "links",
      "block": 2,
      "von": 1702,
      "bis": 1716,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 58,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 9,
      "seite": "links",
      "block": 3,
      "von": 1687,
      "bis": 1701,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 58,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 9,
      "seite": "rechts",
      "block": 4,
      "von": 1852,
      "bis": 1866,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 58,
      "spalte": 13
    },
    {
      "etage": "OG",
      "band": 9,
      "seite": "rechts",
      "block": 5,
      "von": 1837,
      "bis": 1851,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 58,
      "spalte": 16
    },
    {
      "etage": "OG",
      "band": 9,
      "seite": "rechts",
      "block": 6,
      "von": 1822,
      "bis": 1836,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": false,
      "bodenOben": false,
      "zeile": 58,
      "spalte": 19
    },
    {
      "etage": "OG",
      "band": 10,
      "seite": "links",
      "block": 1,
      "von": 1732,
      "bis": 1746,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 65,
      "spalte": 2
    },
    {
      "etage": "OG",
      "band": 10,
      "seite": "links",
      "block": 2,
      "von": 1747,
      "bis": 1761,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 65,
      "spalte": 5
    },
    {
      "etage": "OG",
      "band": 10,
      "seite": "links",
      "block": 3,
      "von": 1762,
      "bis": 1776,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 65,
      "spalte": 8
    },
    {
      "etage": "OG",
      "band": 10,
      "seite": "rechts",
      "block": 4,
      "von": 1777,
      "bis": 1791,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 65,
      "spalte": 13
    },
    {
      "etage": "OG",
      "band": 10,
      "seite": "rechts",
      "block": 5,
      "von": 1792,
      "bis": 1806,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 65,
      "spalte": 16
    },
    {
      "etage": "OG",
      "band": 10,
      "seite": "rechts",
      "block": 6,
      "von": 1807,
      "bis": 1821,
      "breite": 3,
      "hoehe": 5,
      "aufsteigend": true,
      "bodenOben": true,
      "zeile": 65,
      "spalte": 19
    }
  ],
  "spalten": "B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1L1K1J1I1L1K1J1I1L1K1J1I1L1K1J1I1L1K1J1I1H1G1F1E1H1G1F1E1H1G1F1E1H1G1F1E1H1G1F1E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1L1K1J1I1L1K1J1I1L1K1J1I1L1K1J1I1L1K1J1I1L1K1J1I1H1G1F1E1H1G1F1E1H1G1F1E1H1G1F1E1H1G1F1E1H1G1F1E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1E1F1G1H1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1I1J1K1L1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1L1J2I1L1J2I1L1J2I1L1J2I1L1J2I1L1J2I1H1F2E1H1F2E1H1F2E1H1F2E1H1F2E1H1F2E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F2H1E1F2H1E1F2H1E1F2H1E1F2H1E1F2H1I1J2L1I1J2L1I1J2L1I1J2L1I1J2L1I1J2L1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1L1J2I1L1J2I1L1J2I1L1J2I1L1J2I1L1J2I1H1F2E1H1F2E1H1F2E1H1F2E1H1F2E1H1F2E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F2H1E1F2H1E1F2H1E1F2H1E1F2H1E1F2H1I1J2L1I1J2L1I1J2L1I1J2L1I1J2L1I1J2L1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1L1J2I1L1J2I1L1J2I1L1J2I1L1J2I1L1J2I1H1F2E1H1F2E1H1F2E1H1F2E1H1F2E1H1F2E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1X1V2U1X1V2U1X1V2U1X1V2U1X1V2U1T1R2Q1T1R2Q1T1R2Q1T1R2Q1T1R2Q1Q1R2T1Q1R2T1Q1R2T1Q1R2T1Q1R2T1Q1R2T1U1V2X1U1V2X1U1V2X1U1V2X1U1V2X1U1V2X1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1[1Z1Y1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1X1W1V1U1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1T1S1R1Q1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1Q1R1S1T1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1U1V1W1X1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1Y1Z1[1J1I1H1J1I1H1J1I1H1J1I1H1G1F1E1G1F1E1G1F1E1G1F1E1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1E1F1G1E1F1G1E1F1G1E1F1G1H1I1J1H1I1J1H1I1J1H1I1J1H1I1J1J1I1H1J1I1H1J1I1H1J1I1H1J1I1H1G1F1E1G1F1E1G1F1E1G1F1E1G1F1E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1H1I1J1H1I1J1H1I1J1H1I1J1H1I1J1J1I1H1J1I1H1J1I1H1J1I1H1J1I1H1G1F1E1G1F1E1G1F1E1G1F1E1G1F1E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1E1F1G1E1F1G1E1F1G1E1F1G1H1I1J1H1I1J1H1I1J1H1I1J1H1I1J1J1I1H1J1I1H1J1I1H1J1I1H1J1I1H1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1E1F1G1E1F1G1E1F1G1E1F1G1H1I1J1H1I1J1H1I1J1H1I1J1H1I1J1J1I1H1J1I1H1J1I1H1J1I1H1J1I1H1G1F1E1G1F1E1G1F1E1G1F1E1G1F1E1D1C1B1D1C1B1D1C1B1D1C1B1D1C1B1B1C1D1B1C1D1B1C1D1B1C1D1B1C1D1E1F1G1E1F1G1E1F1G1E1F1G1E1F1G1H1I1J1H1I1J1H1I1J1H1I1J1H1I1J1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1P1Q1R1P1Q1R1P1Q1R1P1Q1R1P1Q1R1S1T1U1S1T1U1S1T1U1S1T1U1S1T1U1U1T1S1U1T1S1U1T1S1U1T1S1U1T1S1R1Q1P1R1Q1P1R1Q1P1R1Q1P1R1Q1P1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1M1N1O1M1N1O1M1N1O1M1N1O1M1N1O1P1Q1R1P1Q1R1P1Q1R1P1Q1R1P1Q1R1S1T1U1S1T1U1S1T1U1S1T1U1S1T1U1U1T1S1U1T1S1U1T1S1U1T1S1U1T1S1O1N1M1O1N1M1O1N1M1O1N1M1O1N1M1"
}
